import { render } from "./FileTypeIcon.vue?vue&type=template&id=824bcbdc&scoped=true"
import script from "./FileTypeIcon.vue?vue&type=script&lang=js"
export * from "./FileTypeIcon.vue?vue&type=script&lang=js"

import "./FileTypeIcon.vue?vue&type=style&index=0&id=824bcbdc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-824bcbdc"]])

export default __exports__